/**
 * search-header
 */

import Component, { nextTick, subscribe } from '../../js/lib/component';
import $ from 'jquery';

const classList = {
  root: '.js-search-header',
  label: '.js-search-header-label',
  field: '.js-search-header-field'
};

export default class SearchHeader extends Component {
  events() {
    this.$.label.on('click', () => this.open());
    this.$.document.on('click', e => this.close(e));
    subscribe('page:esc', () => this.close());
  }
  open() {
    this.$.root.addClass('is-open');
    this.$.field.focus();

    nextTick().then(() => {
      this.state.open = true;
    });
  }
  close(e) {
    if (e) {
      const $target = $(e.target);

      const isRoot = $target.is(classList.root);
      const isChilds = $target.closest(classList.root).length > 0;

      if (isRoot || isChilds) return;
    }

    if (this.state.open) {
      this.$.root.removeClass('is-open');
      this.$.field.val('');
      this.state.open = false;
    }
  }
}

Component.mount(SearchHeader, {
  name: 'SearchHeader',
  classList,
  state: {
    open: false
  }
});
